<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>
            <el-menu-item index="/home/chapterManagement/chapterManagementLi">用章管理</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'chapterManagement',
    data() {
      return {
        msg: '用章管理',
        activeIndex: '/home/chapterManagement/chapterManagementLi',
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        }
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// chapterManagementMenu.vue?2ebede3b